import { graphqlErrorMessage } from '@/lib/graphqlError';

export function QueryErrorNotice({
  error,
  title = 'Could not load this data',
}: {
  error: unknown;
  title?: string;
}) {
  if (!error) return null;
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-950 dark:border-amber-900/40 dark:bg-amber-950/40 dark:text-amber-100">
      <p className="font-medium">{title}</p>
      <p className="mt-1">{graphqlErrorMessage(error)}</p>
    </div>
  );
}
